var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailblue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(0 0.057373)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4035 7.11798L11.9999 11.9156L21.5963 7.11798C21.5608 6.50651 21.2928 5.93176 20.8473 5.51145C20.4018 5.09114 19.8124 4.85707 19.1999 4.85718H4.7999C4.1874 4.85707 3.59804 5.09114 3.15252 5.51145C2.70699 5.93176 2.43903 6.50651 2.4035 7.11798Z",
    fill: "#2499F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5999 9.79878L11.9999 14.5988L2.3999 9.79878V16.8572C2.3999 17.4937 2.65276 18.1041 3.10285 18.5542C3.55293 19.0043 4.16338 19.2572 4.7999 19.2572H19.1999C19.8364 19.2572 20.4469 19.0043 20.897 18.5542C21.347 18.1041 21.5999 17.4937 21.5999 16.8572V9.79878Z",
    fill: "#2499F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailblue);
export default __webpack_public_path__ + "static/media/mailblue.a0bec3972a1222cd5216ea881ebffaa6.svg";
export { ForwardRef as ReactComponent };